import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_GENERATE_IN_TUNE_ASSESSMENTS')